// extracted by mini-css-extract-plugin
export default {"dialog":"gyFDHFsr","title":"x7Tq91rL","buttons":"_jbJkzRV","body":"k_HhA4jN"};